import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AbstractModalWithFormComponent } from 'app/shared/components/abstract-modal-with-form.component';
import { Subject, Subscription } from 'rxjs';
import { AppConfiguration } from '../../../core/models/app-configuration.model';
import { Moment } from 'moment';

/**
 * TwoStepVerificationModalComponent
 * @description Implements all logic for enabling two factor authentication
 */
@Component({
  selector: 'ap-progr-password-modal',
  templateUrl: 'progr-password-modal.component.html',
})
export class ProgPasswordModalComponent extends AbstractModalWithFormComponent implements OnDestroy {

  pairResult: 'success' | 'failure' = 'success';
  expireDate?: Moment;

  pollingSubscription?: Subscription;
  eventsFocus: Subject<boolean> = new Subject<boolean>();


  constructor(
    public activeModal: NgbActiveModal,
    protected translateService: TranslateService,
    public appConfig: AppConfiguration
  ) {
    super(translateService, 'accountSecurity.twoFactorAuth.principal.modal.activation', 'accountSecurity.twoFactorAuth.errors');
  }
  /**
   * Check if user has write verification code correctly
   * @param code verification code
   */

  goProgramPassword() {
    this.activeModal.close(true);
  }

  cancelAction() {
    this.activeModal.close(false);
  }

  /**
   * Clean observable before component destroy
   */
  ngOnDestroy(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }
}
